import _defineProperty2 from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/runner/_work/developers/developers/node_modules/@babel/runtime/regenerator/index.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/* eslint-disable no-console */
var _require = require('uuid'),
  uuidv4 = _require.v4;
var OptimizelyService = /*#__PURE__*/function () {
  function OptimizelyService() {
    _classCallCheck(this, OptimizelyService);
  }
  _createClass(OptimizelyService, null, [{
    key: "genericRequestHandler",
    value: function genericRequestHandler(request) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$onError = _ref.onError,
        onError = _ref$onError === void 0 ? function () {} : _ref$onError;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return request();
            case 3:
              return _context.abrupt("return", _context.sent);
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              onError(_context.t0);
              return _context.abrupt("return", {
                ok: false,
                error: _context.t0
              });
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 6]]);
      }))();
    }
  }, {
    key: "activateExperiment",
    value: function activateExperiment(_ref2) {
      var userId = _ref2.userId,
        campaignId = _ref2.campaignId,
        experimentId = _ref2.experimentId,
        variationId = _ref2.variationId,
        _ref2$attributes = _ref2.attributes,
        attributes = _ref2$attributes === void 0 ? [] : _ref2$attributes;
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", _this.genericRequestHandler( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                var result;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return fetch(_this.ENDPOINT, {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                          account_id: _this.ACCOUNT_ID,
                          visitors: [{
                            visitor_id: userId,
                            attributes: attributes,
                            snapshots: [{
                              decisions: [{
                                campaign_id: campaignId,
                                experiment_id: experimentId,
                                variation_id: variationId
                              }],
                              events: [{
                                entity_id: campaignId,
                                type: 'campaign_activated',
                                timestamp: Date.now(),
                                uuid: uuidv4()
                              }]
                            }]
                          }],
                          enrich_decisions: true
                        })
                      }, {
                        onError: function onError(error) {
                          console.warn("[Optimizely] Failed to activate experiment ".concat(experimentId, " with variation ").concat(variationId, " for user ").concat(userId, ". Status: ").concat(result.status));
                          console.error(error);
                        }
                      });
                    case 2:
                      result = _context2.sent;
                      return _context2.abrupt("return", {
                        ok: result.ok
                      });
                    case 4:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }))));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }, {
    key: "trackEvent",
    value: function trackEvent(_ref3) {
      var userId = _ref3.userId,
        eventId = _ref3.eventId,
        _ref3$attributes = _ref3.attributes,
        attributes = _ref3$attributes === void 0 ? [] : _ref3$attributes;
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", _this2.genericRequestHandler( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                var result;
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return fetch(_this2.ENDPOINT, {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                          account_id: _this2.ACCOUNT_ID,
                          visitors: [{
                            visitor_id: userId,
                            attributes: attributes,
                            snapshots: [{
                              decisions: [],
                              events: [{
                                entity_id: eventId,
                                timestamp: Date.now(),
                                uuid: uuidv4()
                              }]
                            }]
                          }],
                          enrich_decisions: true
                        })
                      });
                    case 2:
                      result = _context4.sent;
                      return _context4.abrupt("return", result.ok);
                    case 4:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }))));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    }

    /**
     * @param {string} [experimentsString] - <campaign_id>:<experiment_id>:<variation_id>:<experiment_key>:<variation_key>[-<campaign_id>:<experiment_id>:<variation_id>:<experiment_key>:<variation_key>]* **/
  }, {
    key: "normaliseExperiments",
    value: function normaliseExperiments() {
      var experimentsString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var regex = /^([0-9]+:[0-9]+:[0-9]+(:\w+)?(:\w+)?)(-[0-9]+:[0-9]+:[0-9]+(:\w+)?(:\w+)?)*$/;
      if (!regex.test(experimentsString)) {
        // eslint-disable-next-line no-console
        console.warn("[OptimizelyService.normaliseExperiments] The experiments string doesn't match the expected pattern: <campaign_id>:<experiment_id>:<variation_id>:<experiment_key>:<variation_key>[-<campaign_id>:<experiment_id>:<variation_id>:<experiment_key>:<variation_key>]* Received: ".concat(experimentsString));
        return {};
      }
      var experimentsArray = experimentsString.split('-');
      return experimentsArray.reduce(function (accum, current) {
        var _current$split = current.split(':'),
          _current$split2 = _slicedToArray(_current$split, 5),
          campaignId = _current$split2[0],
          experimentId = _current$split2[1],
          variationId = _current$split2[2],
          _current$split2$ = _current$split2[3],
          experimentKey = _current$split2$ === void 0 ? null : _current$split2$,
          _current$split2$2 = _current$split2[4],
          variationKey = _current$split2$2 === void 0 ? null : _current$split2$2;
        return _objectSpread(_objectSpread({}, accum), {}, _defineProperty2({}, experimentId, {
          variationId: variationId,
          campaignId: campaignId,
          experimentKey: experimentKey,
          variationKey: variationKey
        }));
      }, {});
    }
  }, {
    key: "getForcedExperiment",
    value: function getForcedExperiment() {
      var experimentQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return experimentQuery.split('-').map(function (experiment) {
        return experiment.split(':');
      }).filter(function (experimentValues) {
        return experimentValues.every(Boolean);
      }).reduce(function (prev, _ref4) {
        var _ref5 = _slicedToArray(_ref4, 5),
          campaignId = _ref5[0],
          experimentId = _ref5[1],
          variationId = _ref5[2],
          experimentKey = _ref5[3],
          variationKey = _ref5[4];
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty2({}, experimentId, {
          variationId: variationId,
          campaignId: campaignId,
          experimentKey: experimentKey,
          variationKey: variationKey
        }));
      }, {});
    }
  }, {
    key: "getExperimentsFromRequest",
    value: function getExperimentsFromRequest(_ref6) {
      var req = _ref6.req,
        res = _ref6.res;
      var _req$query;
      var experimentQuery = (_req$query = req.query) === null || _req$query === void 0 ? void 0 : _req$query['optimizely-experiments'];
      if (experimentQuery) {
        return OptimizelyService.getForcedExperiment(experimentQuery);
      }
      var rawExperiments = req.headers[OptimizelyService.OPTIMIZELY_RAW_EXPERIMENTS_HEADER];
      var experiments = req.headers[OptimizelyService.OPTIMIZELY_EXPERIMENTS_HEADER];
      res.setHeader(OptimizelyService.OPTIMIZELY_EXPERIMENTS_HEADER, experiments || '');
      res.setHeader(OptimizelyService.OPTIMIZELY_RAW_EXPERIMENTS_HEADER, rawExperiments || '');
      return experiments ? OptimizelyService.normaliseExperiments(experiments) : {};
    }
  }]);
  return OptimizelyService;
}();
OptimizelyService.ENDPOINT = 'https://logx.optimizely.com/v1/events';
OptimizelyService.ACCOUNT_ID = '15381830540';
OptimizelyService.OPTIMIZELY_RAW_EXPERIMENTS_HEADER = 'x-experiments-raw';
OptimizelyService.OPTIMIZELY_EXPERIMENTS_HEADER = 'x-experiments';
export default OptimizelyService;